import styled from 'styled-components';

const TONES = {
  ok: { border: 'rgba(37, 211, 102, 0.35)', bg: 'rgba(37, 211, 102, 0.08)', icon: '#25d366' },
  warn: { border: 'rgba(245, 158, 11, 0.40)', bg: 'rgba(245, 158, 11, 0.10)', icon: '#f59e0b' },
  block: { border: 'rgba(220, 38, 38, 0.35)', bg: 'rgba(220, 38, 38, 0.08)', icon: '#dc2626' },
};
const tone = (props) => TONES[props.$tone] || TONES.ok;

export const Card = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 34px 12px 12px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: 1px solid ${(props) => tone(props).border};
  background: ${(props) => tone(props).bg};
`;

export const Icon = styled.div`
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: ${(props) => tone(props).icon};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;

  strong {
    font-size: 14px;
    color: #1f2937;
    line-height: 1.3;
  }

  span {
    font-size: 12px;
    color: #666;
  }
`;

export const Action = styled.button`
  margin-top: 6px;
  align-self: flex-start;
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: var(--primary-color);
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const Note = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 7px 9px;
  border-radius: 7px;
  border: 1px solid rgba(37, 211, 102, 0.30);
  background: rgba(37, 211, 102, 0.10);
  font-size: 11px;
  line-height: 1.35;
  color: #1f7a45;

  svg {
    flex: 0 0 auto;
    margin-top: 1px;
  }
`;

export const Close = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  color: #999;
  background: transparent;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
    color: #333;
  }
`;
